import {TrackingEventTypes} from 'epic-diesel-common/src/constants/Tracking';
import {flattenObject} from '../utils/Utils';

const TYPES = {
    TRACK_EVENT: 'TRACK_EVENT'
};

export const EVENT_CATEGORY = {
    MediaCreator: 'MediaCreator',
    AffiliateReactivate: 'AffiliateReactivate',
    AffiliateMigrate: 'AffiliateMigrate',
    AffiliateSignup: 'AffiliateSignup',
    News: 'News',
    TaxIdentity: 'TaxIdentity',
    Hyperwallet: 'Hyperwallet',
    SocialChannel: 'SocialChannel',
    FortniteGames: 'FortniteGames',
    TalonCaptcha: 'TalonCaptcha'
};

export const EVENT_ACTION = {
    // news
    ClickNewsArticle: 'ClickNewsArticle',

    // application
    ClickApply: 'ClickApply',
    ClickReactivate: 'ClickReactivate',

    // social oauth
    BeginAuthChannel: 'BeginAuthChannel', //platform
    AuthChannelSuccess: 'AuthChannelSuccess', //platform
    AuthChannelFail: 'AuthChannelFail', //platform
    UpdateMainChannel: 'UpdateMainChannel', //platform

    // tax
    ClickHyperwalletLink: 'ClickHyperwalletLink',
    ClickConsentLink: 'ClickConsentLink',
    ClickTakeTaxIdLink: 'ClickTakeTaxIdLink',
    ClickRetakeTaxIdLink: 'ClickRetakeTaxIdLink',

    // dashboard games
    FetchBrowseGames: 'FetchBrowseGames',
    ClickBrowseGamesCopyReferralLink: 'ClickBrowseGamesCopyReferralLink',
    ClickBrowseGamesSort: 'ClickBrowseGamesSort',
    ClickBrowseGamesPaginate: 'ClickBrowseGamesPaginate',
    SearchBrowseGamesKeywords: 'SearchBrowseGamesKeywords',

    // dashboard chart
    ClickSupporterChartGame: 'ClickSupporterChartGame',
    ClickSupporterChartCopyReferralLink: 'ClickSupporterChartCopyReferralLink',

    // errors
    Error: 'Error'
};

export interface TrackEventParams {
    eventCategory: string;
    eventAction: string;
    eventType?: TrackingEventTypes;
    data?: object;
    interactionType?: string;
}

interface FlattenOptions {
    prefix?: string;
    result?: object;
    untilDepth?: number;
}

export default {
    TYPES,

    trackInteractionEvent: <T extends object>(
        eventCategory: string,
        eventAction: string,
        data?: T,
        {prefix, untilDepth}: FlattenOptions = {}
    ) => ({
        type: TYPES.TRACK_EVENT,
        payload: {
            eventType: TrackingEventTypes.Interaction,
            interactionType: 'Interaction',
            eventCategory,
            eventAction,
            ...flattenObject(data, {}, prefix, untilDepth)
        }
    }),

    trackClickEvent: <T extends object>(
        eventCategory: string,
        eventAction: string,
        data?: T,
        {prefix, untilDepth}: FlattenOptions = {}
    ) => ({
        type: TYPES.TRACK_EVENT,
        payload: {
            eventType: TrackingEventTypes.Interaction,
            interactionType: 'Click',
            eventCategory,
            eventAction,
            ...flattenObject(data, {}, prefix, untilDepth)
        }
    }),

    trackCustomEvent: <T extends TrackEventParams>(
        {
            eventCategory,
            eventAction,
            data = {},
            interactionType = 'Interaction',
            eventType = TrackingEventTypes.Interaction
        }: T,
        {prefix, untilDepth}: FlattenOptions = {}
    ) => ({
        type: TYPES.TRACK_EVENT,
        payload: {
            interactionType,
            eventCategory,
            eventAction,
            eventType,
            ...flattenObject(data, {}, prefix, untilDepth)
        }
    })
};
